<template>
  <div id="channelBox" class="statv_wrapper">
    <h3 class="disabled"> CHANNEL NUMBER </h3>
    <div class="channel_header" v-show="channels.length > 0">
      <p class="title">CHANNEL NUMBER</p>
    </div>
    <div class="channel_contents">
      <div 
        class="channel_item"
        v-for="(channel, idx) in channels" 
        :key="`channel_${idx}`">
        <p class="channel_name">{{channel.name}}</p>
        <p class="channel_num">{{channel.number}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import * as Store from '@/store/modules/channel'
export default {
	data() {
		return {

		}
	},
	computed: {
		...Store.mapState([
		'channels'
		]),
	},
	async created() {
		await this.getChannels()
	},
	methods: {
		...Store.mapActions([
		'getChannels'
		]),
	}
}
</script>
<style lang="less">
#channelBox {
  .channel_header {
    color: #ff6400;
    letter-spacing: 0;
    margin-bottom: 3px;

    &::before {
      left: 0;
      transition: 0.3s;
    }
    &::after {
      right: 0;
      transition: 0.3s;
    }
    .title {
      height: 47px;
      font-size: 36px;
      font-weight: normal;
      font-family: "BebasNeue";
    }
  }
  .channel_contents {
    display: flex;
    gap: 6px;

    .channel_item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px 6px 16px;
      background-color: #ff8228;
      color: #ffffff;

      .channel_name {
        height: 26px;
        font-weight: 900;
        font-size: 24px;
        color: #ffffff;
      }
      .channel_num {
        height: 34px;
        font-weight: 900;
        font-size: 30px;
        &::before {
          content: "ch";
          font-weight: normal;
        }
      }
    }
  }
}

.m #channelBox {
  .channel_header {
    margin-bottom: 13px;
    &::before, &::after {
      width: calc((100% - 314px)/2);
    }
    .title {
      height: 66px;
      font-size: 50px;
    }
  }
  .channel_contents {
    .channel_item {
      width: 100%;
      flex-direction: column;
      gap: 10px;
      padding: 0;
      background-color: transparent;

      .channel_name {
        width: 100%;
        height: 46px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ff8228;
        color: #ffffff;
        text-align: center;
      }
      .channel_num {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        color: #ff6400;
        text-align: center;
      }
    }
  }

}
</style>